
export const REQUEST_MESSAGES = 'REQUEST_MESSAGES'
export const RECEIVE_MESSAGES = 'RECEIVE_MESSAGES'
export const REQUEST_SAVE_MESSAGE = 'REQUEST_SAVE_MESSAGE'
export const RECEIVE_SAVE_MESSAGE = 'RECEIVE_SAVE_MESSAGE'
